import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ServicesPage from '@/pages/services/page';
import PricingPage from '@/pages/pricing/page';
import ContactPage from '@/pages/contact/page';
import PrivacyPage from '@/pages/privacy/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/pricing', element: <PricingPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
